import { BFF_BASE_PATH } from "@/core/utils"

/**
 * Handle automatic logout on user inactivity
 * also keep server session while user is active
 *
 */
export class SessionTimeout {
  /*constructor()
	{
        this.retry = 0;
        this.inactivityTimeoutMsec = 900*1000; // default 15 minute
        this.getSessionConfig();
    }*/

  constructor(timeoutSec) {
    this.retry = 0;
    this.initTimeout(timeoutSec);
  }

  /*
   * set timer for inactivity, listen to user events
   * set timer for keep server session while user is active
   */
  initTimeout(timeoutSec) {
    this.inactivityTimeoutMsec = timeoutSec * 1000;
    this.refreshTimeout();

    $(document).on("click", this.refreshTimeout.bind(this));
    $(document).on("keydown", this.refreshTimeout.bind(this));

    this.keepSessionTimeoutMsec = 600 * 1000;
    this.keepSessionHandle = setTimeout(this.keepSession.bind(this), this.keepSessionTimeoutMsec);
  }

  refreshTimeout() {
    if (this.timeoutHandle != null) clearTimeout(this.timeoutHandle);

    this.timeoutHandle = setTimeout(this.innactivity.bind(this), this.inactivityTimeoutMsec);
  }

  keepSession() {
    var obj = this;
    $.ajax({
      type: "PUT",
      url: `${BFF_BASE_PATH}/keep_session`,
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("ERROR keep_session status" + jqXHR.status + " " + textStatus);
        return false;
      },
      success: function (_data) {
        obj.keepSessionHandle = setTimeout(obj.keepSession.bind(obj), obj.keepSessionTimeoutMsec);
      },
    });
  }

  innactivity() {
    clearTimeout(this.keepSessionHandle);
    utils.eventBridgeApi('logout');
  }

  /*
   * get innactivity time from server
   *
   */
  getSessionConfig() {
    var obj = this;
    $.ajax({
      type: "GET",
      url: `${BFF_BASE_PATH}/get_session_config`,
      dataType: "json",
      timeout: "3000",
      error: function () {
        if (obj.retry < 3) {
          obj.retry++;
          obj.getSessionConfig();
          return;
        }
        console.log("Timeout error - getSessionConfig");
        obj.retry = 0;
        obj.initTimeout(900 * 1000);
      },
      success: function (_data) {
        obj.retry = 0;
        obj.initTimeout(_data["inactivity_timeout_sec"]);
      },
    });
  }
}
